// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Erwartungswert } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteErwartungswert(): (
  aufgabeId: string,
  unteraufgabeId: string,
  erwartungswertId: string
) => Promise<Erwartungswert> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, unteraufgabeId, erwartungswertId) =>
      (await getAPI()).erwartungswerte.deleteErwartungswert({
        aufgabeId,
        unteraufgabeId,
        erwartungswertId,
      }),
    [getAPI]
  );
}
